import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import Settle from 'view/settle';

const SettleManagePage = () => {
	return (
		<PageTemplate>
			<Settle />
		</PageTemplate>
	);
};

export default SettleManagePage;

 